module.exports = __webpack_public_path__ + "img/11.5ef03c1a.webp";